var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStairs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_5002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8757 0L5.20749 0.9571V3.89588L2.60376 4.51454V7.45359L0 8.07227V11.5752L5.27886 15.2807L5.47142 15.2349L14.1546 13.0862V3.70574L8.8757 0ZM5.04224 14.0553L0.872993 11.1287V9.09402L5.04224 12.0427V14.0553ZM5.43832 11.5261L1.35594 8.639L3.11661 8.22057L7.19902 11.108L5.43832 11.5261ZM7.646 10.6272L3.47675 7.6785V5.53628L7.646 8.48497V10.6272ZM8.04208 7.96838L3.95967 5.081L5.72006 4.66287L9.80277 7.55049L8.04208 7.96838ZM10.2497 7.06972L6.08048 4.12103V1.97861L10.2497 4.92753V7.06972ZM10.6458 4.41118L6.56312 1.5238L8.69418 0.931881L12.7994 3.81407L10.6458 4.41118Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_5002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4331,
    height: 15.2807,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairs);
export default __webpack_public_path__ + "static/media/stairs.8b8376ae45b63ea80ed8aea133bc70bf.svg";
export { ForwardRef as ReactComponent };